import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { SITE_NAME, SITE_SLOGAN } from "@/config/site";

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6">
        <div className="grid gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-base font-black text-background-50">
                漫
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">
                {SITE_NAME}
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-6 text-foreground-600">
              {SITE_SLOGAN}。每日精选日漫恋爱、热血、悬疑、治愈、机战等热门题材神作，
              榜单持续更新，助你快速摆脱漫荒。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-950">精选题材</h3>
            <ul className="mt-4 space-y-2">
              {categories.map((c) => (
                <li key={c.slug}>
                  <Link
                    to={`/category/${c.slug}`}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-700"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-950">快速导航</h3>
            <ul className="mt-4 space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-600 transition-colors hover:text-primary-700">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 transition-colors hover:text-primary-700">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/category/shenzuo" className="text-sm text-foreground-600 transition-colors hover:text-primary-700">
                  日漫神作精选
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 text-xs text-foreground-500 sm:flex-row">
          <p>© {new Date().getFullYear()} {SITE_NAME} 版权所有 · 仅作内容分享与推荐</p>
          <p>部分作品简介仅供参考，以官方资讯为准</p>
        </div>
      </div>
    </footer>
  );
}